export default __webpack_public_path__ + "static/umagine_case_study_thumb-2d9451e4ef862c485111adefc167b7de.png";